/*
 * @Author: 张印 hbzyin@163.com
 * @FilePath: /mall-fe/src/pages/product/detail/index.tsx
 * @Description: 商品详情页路由组件
 */
import ProductDetail from '@/views/h5/product/Detail';
import ProductDetailWeb from 'views/web/product/Detail';
import { MediaQueryContext } from 'libs/contexts';
import { useContext } from 'react';
import { getCategory } from 'api/user';
import { apiGetProductDetail } from 'api/mall';
import { allSettled, isMobileMall, strToObj } from 'libs/utils';
import { GetServerSideProps } from 'next';
import { apiGetShopInfoBySkuSysNo } from 'api/shop';

export default function ProductDetailPage(props: any) {
  const { isMobile } = useContext(MediaQueryContext);
  if (isMobile) return <ProductDetail />;
  return <ProductDetailWeb {...props} />;
}

export const getServerSideProps: GetServerSideProps = async (ctx: any) => {
  const serverHeaders = ctx.req.headers;
  if (!isMobileMall(ctx?.req)) {
    const tenantCode = ctx.req?._tenantCode || 'TC00000030';
    const AREA_SYS_NO_KEY = `${tenantCode}_area_sys_no`; // 租户所在地区存取key
    const cookie = strToObj(serverHeaders.cookie);
    const areaSysNo = cookie[AREA_SYS_NO_KEY] ?? '0';
    const apiList = [
      getCategory({
        serverSide: true,
        headers: serverHeaders,
      }),
      apiGetProductDetail({
        serverSide: true,
        headers: serverHeaders,
        json: {
          areaSysNo: areaSysNo,
          sysNo: ctx.query.id,
        },
      }),
      apiGetShopInfoBySkuSysNo(ctx.query.id, {
        serverSide: true,
        headers: serverHeaders,
      }),
    ];
    const allData = await allSettled(apiList);
    const [categoryRes, productDetailRes, shopDataRes] = allData;
    const productDetailData = productDetailRes.data?.data || {};
    const shopData = shopDataRes.data?.data || {};
    if (shopData?.sysNo === '1047548387118899707') {
      // 创新专区店铺特殊处理，不显示价格@张政需求
      productDetailData.showPrice = false;
    }
    return {
      props: {
        categories: categoryRes.data?.data?.categories || [],
        productDetailData,
        shopData,
      },
    };
  }
  return {
    props: {},
  };
};
